module.exports = __webpack_public_path__ + "static/media/Pending_Release.87059e8d.svg";